module.exports = __webpack_public_path__ + "static/img/Roboto-Bold.724edf37.svg";